import { ILoginFormProps } from "./LoginForm.types";
import LoginFormContainer from "./LoginForm.container";
import React from "react";

const LoginForm: React.FC<ILoginFormProps> = props => (
  <LoginFormContainer {...props} />
);

export default LoginForm;
